module.exports = __webpack_public_path__ + "img/arrow-left.5064548e.svg";